import type { MenuRecipesState, RecipeCoreId, RecipeUUID } from 'reducers/menu-recipes/recipes'

export const getRecipeIdByCoreId =
  (coreId: RecipeCoreId | null) =>
  (state: MenuRecipesState): RecipeUUID | null =>
    coreId ? state.recipesV3.coreIdToUUID[coreId] || null : null
